import API from '../apiCreate'
import type {
  RequestCreateField,
  RequestUpdateField,
  RequestUpdateItemsSorting,
  ResponseCheckIsUnused,
  ResponseFields,
} from '../types/crm/crm.types'
import type { EmptyResponse } from '../types/base.types'

/** Поля анкеты лида: `/v1/crm-lead-field/*`. */
export const crmFieldApi = {
  getAllFields: (params?: { funnel_id?: number }) =>
    API.get<ResponseFields>(
      `crm-lead-field/get-all-fields${
        params?.funnel_id ? `?funnel_id=${params.funnel_id}` : ''
      }`,
    ),

  insertField: (data: RequestCreateField) => {
    const { is_constant: _isConstant, ...payload } = data as RequestCreateField & {
      is_constant?: boolean
    }
    return API.post<EmptyResponse>('crm-lead-field/insert-field', payload)
  },
  updateField: (id: number, data: RequestUpdateField) => {
    const { is_constant: _isConstant, ...payload } = data as RequestUpdateField & {
      is_constant?: boolean
    }
    return API.patch<EmptyResponse>(
      `crm-lead-field/update-field?id=${id}`,
      payload,
    )
  },
  deleteField: (id: number) =>
    API.post<EmptyResponse>(`crm-lead-field/post-delete?id=${id}`),

  // проверка что поле не использовалось в анкетах (лидах), и его можно изменить/удалить
  checkFieldIsUnused: (id: number) =>
    API.get<ResponseCheckIsUnused>(
      `crm-lead-field/check-field-is-unused?id=${id}`,
    ),
  updateFieldsSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm-lead-field/update-fields-sorting', data),
}
